import { render } from "./CompleteProfileModal.vue?vue&type=template&id=29b74f18&scoped=true&ts=true"
import script from "./CompleteProfileModal.vue?vue&type=script&lang=ts"
export * from "./CompleteProfileModal.vue?vue&type=script&lang=ts"

import "./CompleteProfileModal.vue?vue&type=style&index=0&id=29b74f18&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b74f18"]])

export default __exports__